import React from 'react';
import { Provider } from 'react-redux';
import rootStore from './src/state/root-store';

const wrap = ({ element }) => (
  <Provider store={rootStore.store}>{element}</Provider>
);

export default wrap;
